module.exports = __webpack_public_path__ + "img/7.afe4877f.svg";